import { shape, string } from 'prop-types';

export const IDEA_TAGS = shape({
    tagName: string,
    tagId: string,
    tagType: string,
});
